module.exports = __webpack_public_path__ + "img/img_default.29ee2dd5.png";